import CancellableHelper from "@/requests/CancellableHelper";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import {
  BookingServicesItemsResponse,
  BookingServicesItems,
} from "@/models/api/administration/bookingService/BookingServicesItems";
import { IntegrationListItem } from "@/models/api/administration/integration/integrationListItem";

//#region Routes
export const URL_GET_BOOKING_SERVICE_PAGED = "/BookingServices/Paged";
export const URL_GET_BOOKING_TO_EDIT = "/BookingServices/BookingToEdit";
export const URL_POST_UNLINK = "/BookingServices/UnlinkFromOrderForBookingItem";
export const URL_POST_DELETE_CAPTURE = "/BookingServices/DeleteCaptureForBookingItem";
export const URL_POST_UNVOID = "/BookingServices/UnVoidForBookingItem";
export const URL_POST_UNCANCEL = "/BookingServices/UnCancelledForBookingItem";
export const URL_POST_TOGGLE_IS_LOCKED = "/BookingServices/ToggleIsLockedBookingItem";
export const URL_POST_CANCEL_ITEM = "/BookingServices/CancelBookingsItems";
export const URL_POST_CHECK_IF_EXIST_AND_EXPORT =
  "/BookingServices/CheckIfExistInExportingOfficeAndExportSelectedBookings";
export const URL_GET_INTEGRATION_LIST_TO_EXPORT = "/BookingServices/GetIntegrationListToExport";
//#endregion

const _getBookingServiceTable = new CancellableHelper<BookingServicesItemsResponse>(
  URL_GET_BOOKING_SERVICE_PAGED,
  BookingServicesItemsResponse
);
_getBookingServiceTable.jsonSerializer = true;
export const getBookingServiceTable = async (
  genericTableRequest: GenericTableRequest
): Promise<BookingServicesItemsResponse> => {
  return await _getBookingServiceTable.get(genericTableRequest);
};

const _getBookingToEdit = new CancellableHelper<BookingServicesItems>(URL_GET_BOOKING_TO_EDIT, BookingServicesItems);
export const getBookingToEdit = async (id: number): Promise<BookingServicesItems> => {
  return await _getBookingToEdit.get({ bookingItemId: id });
};

export const unlinkFromOrder = async (bookingId: number): Promise<null> => {
  const _unlinkFromOrder = new CancellableHelper<null>(URL_POST_UNLINK, null, true);
  return await _unlinkFromOrder.post({ bookingId: bookingId }, null);
};

export const deleteCapture = async (bookingId: number): Promise<null> => {
  const _deleteCapture = new CancellableHelper<null>(URL_POST_DELETE_CAPTURE, null, true);
  return await _deleteCapture.post({ bookingId: bookingId }, null);
};

export const unVoid = async (bookingId: number): Promise<null> => {
  const _unVoid = new CancellableHelper<null>(URL_POST_UNVOID, null, true);
  return await _unVoid.post({ bookingId: bookingId }, null);
};

export const unCancel = async (bookingId: number): Promise<null> => {
  const _unCancel = new CancellableHelper<null>(URL_POST_UNCANCEL, null, true);
  return await _unCancel.post({ bookingId: bookingId }, null);
};

export const toggleIsLocked = async (bookingItemId: number): Promise<null> => {
  const _toggleIsLocked = new CancellableHelper<null>(URL_POST_TOGGLE_IS_LOCKED, null, true);
  return await _toggleIsLocked.post({ bookingItemId: bookingItemId }, null);
};

export const cancelBookings = async (serviceTypeIds: number[], toDate: Date, comment: string): Promise<null> => {
  const _cancel = new CancellableHelper<null>(URL_POST_CANCEL_ITEM, null, true);
  return await _cancel.post({ toDate: toDate, comment: comment }, serviceTypeIds);
};

export const checkIfExistAndExport = async (
  integrationId: string,
  exportAgain: boolean,
  bookingItemIdList: Array<number>
): Promise<Array<string>> => {
  const _checkIfExistAndExport = new CancellableHelper<Array<string>>(
    URL_POST_CHECK_IF_EXIST_AND_EXPORT,
    "number",
    true
  );
  return await _checkIfExistAndExport.post(
    { integrationId: integrationId, exportAgain: exportAgain },
    bookingItemIdList
  );
};

const _getIntegrationListToExport = new CancellableHelper<Array<IntegrationListItem>>(
  URL_GET_INTEGRATION_LIST_TO_EXPORT,
  IntegrationListItem
);
export const getIntegrationListToExport = async (): Promise<Array<IntegrationListItem>> => {
  return await _getIntegrationListToExport.get();
};
